export const normalizeTinyMceContent = (content?: string | null) =>
    (content ?? "")
        .replace(/<p>(?:&nbsp;|<br\s*\/?>|\s)*<\/p>/gi, "")
        .replace(/&nbsp;/gi, " ")
        .replace(/\u00a0/g, " ")
        .trim();

export const getReactQuillDraftStorageKey = (draftKey: string) =>
    `react-quill-isolated-${draftKey}-last-message`;

type TinyMceBlobInfo = {
    blob: () => Blob;
    base64: () => string;
};

export const tinyMceInlineImageUploadHandler = (
    blobInfo: TinyMceBlobInfo,
    progress: (percent: number) => void,
) => {
    progress(100);

    return Promise.resolve(
        `data:${blobInfo.blob().type || "image/png"};base64,${blobInfo.base64()}`,
    );
};

const blobToDataUri = (blob: Blob) =>
    new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (typeof reader.result === "string") {
                resolve(reader.result);
            } else {
                reject(new Error("Could not read image blob."));
            }
        };
        reader.onerror = () => reject(reader.error ?? new Error("Could not read image blob."));
        reader.readAsDataURL(blob);
    });

export const inlineBlobImageSources = async (content?: string | null) => {
    const html = content ?? "";
    if (!html.includes("blob:")) {
        return html;
    }

    const container = document.createElement("div");
    container.innerHTML = html;
    const images = Array.from(
        container.querySelectorAll<HTMLImageElement>('img[src^="blob:"]'),
    );

    if (!images.length) {
        return html;
    }

    await Promise.all(
        images.map(async (image) => {
            const source = image.getAttribute("src");
            if (!source) {
                return;
            }

            try {
                const response = await fetch(source);
                if (!response.ok) {
                    return;
                }

                image.setAttribute("src", await blobToDataUri(await response.blob()));
            } catch {
                return;
            }
        }),
    );

    return container.innerHTML;
};
